export const indexBy = <T extends object>(array: T[], indexByKey: string) => {
  const typedKey = indexByKey as keyof T;
  const returnObject: Map<T[keyof T], T> = new Map();
  array.forEach((item) => {
    returnObject.set(item[typedKey], item);
  });

  return returnObject;
};
